import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NewMockupState = {
  name: string;
  collectionId: string;
  styleId: string;
  orgId: string;
  preview: string;
  correlationStyleId?: string;
  styleType?: '3D' | '2D';
};

export type NewMockupSliceState = NewMockupState & {
  isCreating: boolean;
};

const initialState: NewMockupSliceState = {
  name: '',
  collectionId: '',
  styleId: '',
  orgId: '',
  preview: '',
  correlationStyleId: '',
  styleType: '3D',
  isCreating: false,
};

export const newMockup = createSlice({
  name: 'newMockup',
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setCollectionId: (state, action: PayloadAction<string>) => {
      state.collectionId = action.payload;
    },
    setStyleId: (state, action: PayloadAction<string>) => {
      state.styleId = action.payload;
    },
    setOrgId: (state, action: PayloadAction<string>) => {
      state.orgId = action.payload;
    },
    setPreivew: (state, action: PayloadAction<string>) => {
      state.preview = action.payload;
    },
    setIsCreating: (state, action: PayloadAction<boolean>) => {
      state.isCreating = action.payload;
    },
  },
});

export const { setName, setCollectionId, setStyleId, setPreivew, setOrgId, setIsCreating } =
  newMockup.actions;

export const newMockupReducer = newMockup.reducer;
